<template>
  <div>
    <v-card class="px-3">
      <h3 class="pt-1">Product filters</h3>
      <v-layout row wrap align-start>
        <v-flex xs12 class="pb-0">
          <ClientFilter />
        </v-flex>
        <v-flex xs12 lg4>
          <SellersDomainsFilter />
        </v-flex>
        <v-flex xs12 lg8>
          <CharacteristicsFilter/>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable */
import ClientFilter from "./N_ClientFilter";
import SellersDomainsFilter from "./N_SellersDomainsFilter";
import CharacteristicsFilter from "./N_CharacteristicsFilter";

export default {
  name: "N_ProductFilter",
  components: {
    ClientFilter,
    SellersDomainsFilter,
    CharacteristicsFilter,
  },
  data: () => ({
    filters: {
      brand: {
        isLoading: false,
        search: null,
      },
      category: {
        isLoading: false,
        search: null,
      },
      product: {
        isLoading: false,
        search: null,
      },
      sku: {
        isLoading: false,
        search: null,
      },
      ean: {
        isLoading: false,
        search: null,
      },
      allowRequest: true,
    },
    sellerInvert: false,
  }),
  methods: {
    updateByFilters(e, key) {
      if (!this.filters.allowRequest) return;
      this.$store.commit("productModule/SET_selectedFilters", {
        value: e,
        key: key,
      });
    },
    selectedClient(id) {
      this.$emit("selectedClient", id);
    },
    selectedSellers(data) {
      this.$emit("selectedSellers", data);
    },
    selectedDomains(data) {
      this.$emit("selectedDomains", data);
    },
    getFilterPayload(filterTarget) {
      return {
        filterTarget,
        client_selection: this.clientId,
        seller_selection: this.sellerIds,
        domain_selection: this.domainIds,
        brand_selection: this.getSelectedFilters.brand,
        name_selection: this.getSelectedFilters.product,
        category_selection: this.getSelectedFilters.category,
        sku_selection: this.getSelectedFilters.sku,
        ean_selection: this.getSelectedFilters.ean,
      };
    },
    handleKeyDown(event) {
      if (event.code === 'Space') {
        const isTextField = event.target.tagName.toLowerCase() === 'input';
        if(!isTextField){
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }
    },
    help(a,b,c) {
      console.log('filter', a)
      console.log('idx', b)
      console.log('prop', c)
    }
  },
  computed: {
    loading () {
      return this.$store.state.productionModule.loading;
    },
    loaded_products_length () {
      return this.$store.state.productionModule.loaded_products.length;
    },
    product_filter() {
      return this.$store.state.productionModule.product_filter;
    },
    client_name () {
      return (this.product_filter.selected_client != '0')
        ? this.$store.state.productionModule.clients_list.find(c => c.value == this.product_filter.selected_client).text
        : '';
    },
    total_pendings() {
      return this.$store.state.productionModule.clients_list.reduce((a,b) => (a+b.Pending), 0);
    },
    total_for_check() {
      return this.$store.state.productionModule.clients_list.reduce((a,b) => (a+b.ReCheck), 0);
    },
    condition() { return [null,0,1,2].includes(this.product_filter.status) },
    show_list() { return this.$store.state.productionModule.lists.find(l => l.list_id === this.product_filter.list).title },
  },
  watch: {
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/production/N_ProductFilter.vue